import { Component, OnInit, TemplateRef, ViewChild, AfterViewInit } from '@angular/core';
import { ReportService } from '../../../../common/services/Report.service';

declare var $: any;
declare var Chartist: any;

@Component({
  templateUrl: 'report.template.html',
  styleUrls: ['report.component.css'],
  providers: [ReportService],
})
export class ReportComponent implements OnInit {
  public layout = 'summary';

  constructor(private reportService: ReportService) {}

  ngOnInit() {
    this.layout = 'summary';
  }

  changeLayout(type) {
    this.layout = type;
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/report/report.component.ts